module.exports = __webpack_public_path__ + "img/t.940eb079.svg";